import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuickLinks = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.03 18.84L8.01 21.86C6.57 23.3 4.06 23.3 2.62 21.86C1.9 21.14 1.5 20.18 1.5 19.17C1.5 18.16 1.9 17.2 2.62 16.48L8.78 10.32C10.22 8.88002 12.73 8.88002 14.17 10.32L15.31 11.46C15.6 11.75 16.08 11.75 16.37 11.46C16.66 11.17 16.66 10.69 16.37 10.4L15.23 9.26002C13.16 7.19002 9.79 7.19002 7.72 9.26002L1.56 15.42C0.559999 16.42 0 17.76 0 19.17C0 20.58 0.549999 21.92 1.56 22.92C2.56 23.92 3.9 24.48 5.31 24.48C6.72 24.48 8.06 23.93 9.06 22.92L12.08 19.9C12.37 19.61 12.37 19.13 12.08 18.84C11.79 18.55 11.31 18.55 11.02 18.84H11.03Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.92 1.56C21.92 0.559999 20.58 0 19.17 0C17.76 0 16.42 0.549999 15.42 1.56L12.4 4.58C12.11 4.87 12.11 5.35 12.4 5.64C12.69 5.93 13.17 5.93 13.46 5.64L16.48 2.62C17.92 1.18 20.43 1.18 21.87 2.62C22.59 3.34 22.99 4.3 22.99 5.31C22.99 6.32 22.59 7.28 21.87 8L15.71 14.16C14.27 15.6 11.76 15.6 10.32 14.16L9.18003 13.02C8.89003 12.73 8.41003 12.73 8.12003 13.02C7.83003 13.31 7.83003 13.79 8.12003 14.08L9.26003 15.22C10.29 16.26 11.65 16.77 13.01 16.77C14.37 16.77 15.73 16.25 16.76 15.22L22.92 9.06C23.92 8.06 24.48 6.72 24.48 5.31C24.48 3.9 23.93 2.56 22.92 1.56Z",
		fill: "currentColor"
	})]
});
export default SvgQuickLinks;
